import { WebStorageStateStore } from 'oidc-client-ts';
export const oidcConfig = {
    authority: process.env.APP_OIDC_AUTHORITY,
    client_id: process.env.APP_OIDC_CLIENT_ID,
    redirect_uri: process.env.APP_OIDC_REDIRECT_URI,
    post_logout_redirect_uri: process.env.APP_OIDC_POST_LOGOUT_REDIRECT_URI,
    response_type: 'code',
    scope: 'openid budget-calendar-frontend-dedicated',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: sessionStorage }),
};
